import { NODE_TYPES } from '@src/constants/MogamboConstants';
import { ENTITY_CATEGORY } from '@src/constants/Entities';

/**
 * @description Automatically generate node name based on the input parameters
 * @author jatin.parekh
 * @export
 * @param {NODE_TYPES} nodeType
 * @param {string} nodeTitle
 * @param {string} domainName
 * @param {string} storyName
 * @returns {string} generatedNodeName
 */
export function generateNodeName(nodeType, nodeTitle, domainName, storyName) {
  const upperCaseNodeTitle = nodeTitle.toUpperCase();
  let systemName = '';

  switch (nodeType) {
    case NODE_TYPES.BOT_GENERAL:
      systemName = `${domainName}::GEN::${upperCaseNodeTitle}`;
      break;

    case NODE_TYPES.STORY_GENERAL:
      systemName = `${domainName}::${storyName}::GEN::${upperCaseNodeTitle}`;
      break;

    case NODE_TYPES.REGULAR:
      systemName = `${domainName}::${storyName}::${upperCaseNodeTitle}`;
      break;

    default:
      break;
  }

  // System name for a node should not have any characters apart from
  // letters, numbers, underscore and colons
  return systemName.replace(/ /g, '_').replace(/[^a-zA-Z0-9:_]/g, '');
}

/**
 * @description For frontend: Other Bot entities and Deprecated entities should be treated in the same way
 * Hence, we map the entity category from backend to frontend.
 * @author jatin.parekh
 * @export
 * @param {string} entityCategory
 * @param {string} entityDomainName
 * @param {string} nodeDomainName
 * @returns convertedEntityCategory
 */
export function convertEntityCategory(
  entityCategory,
  entityDomainName,
  nodeDomainName
) {
  if (
    entityCategory === ENTITY_CATEGORY.DOMAIN &&
    entityDomainName !== nodeDomainName
  ) {
    return ENTITY_CATEGORY.DEPRECATED;
  }
  return entityCategory;
}
